import React from 'react';
import { useNavigate } from 'react-router-dom'; // Using useNavigate for navigation
import Navbar from '../components/Navbar'; // Adjust the path as needed
import '../styles/CAD.css';

const VAPT = () => {
    const navigate = useNavigate();

    
    const handleNavigation = (path) => {
        navigate(path);
    };

    return (
        <>
            <Navbar />
            <div className="custom-app-development">
                <div className="content-box">
                    <header className="header">
                        <h1>Vulnerability Assessment Penetration Testing (VAPT)</h1>
                        <p className="tagline">
                            Fortify your digital assets with our comprehensive VAPT services.
                        </p>
                    </header>
                    
                    <section className="introduction">
                        <p>
                        In today's changing threat landscape, safeguarding your digital assets is a number one priority. Our VAPT services evaluate your IT infrastructure in depth to find vulnerabilities, thus fixing the vulnerabilities before they can be exploited by attackers.
                        </p>
                    </section>
                    
                    <section className="why-choose-us">
                        <h2>Why Choose Our VAPT Services?</h2>
                        <p>
                        The security team extensively uses dominant methodologies and state-of-the-art tools to imitate real attacks. We give you usable insights and prioritized recommendations to improve your security posture and comply with the regulation.
                        </p>
                    </section>
                    
                    <section className="tech-stack">
                        <h2>Our Testing Methodology & Tools</h2>
                        <p>
                        We supplement automated scanning techniques with rigorous manual testing in order to provide you with more thorough assessment:
                        </p>
                        <ul>
                            <li><strong>Automated Scanning:</strong> Using tools like Nessus, OpenVAS, and Burp Suite.</li>
                            <li><strong>Manual Penetration Testing:</strong> Leveraging frameworks such as Metasploit and custom exploit scripts.</li>
                            <li><strong>Industry Standards:</strong> Adhering to OWASP, NIST, and MITRE ATT&CK frameworks.</li>
                            <li><strong>Actionable Reporting:</strong> Detailed findings with prioritized remediation strategies.</li>
                        </ul>
                    </section>
                    
                    <section className="secure-practices">
                        <h2>Our Approach & Best Practices</h2>
                        <p>
                        We maintain confidentiality and are in strict adherence to best practices during the course of the test. Our methodology includes pre-assessment planning, constant monitoring during tests, and post-assessment support for all types of enduring improvements to security.  </p>
                    </section>
                    
                    <section className="services">
                        <h2>Our VAPT Offerings</h2>
                        <div className="service-container">
                            <div className="service-box">
                                <h3>External Network Testing/Infrastructure Hardening</h3>
                                <p>
                                    Identify vulnerabilities in your outward-facing infrastructure to prevent external breaches.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/external-vapt')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Internal Network Testing</h3>
                                <p>
                                    Simulate insider threats and assess internal security gaps within your network.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/internal-vapt')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Web Application Testing</h3>
                                <p>
                                    Conduct thorough assessments of your web applications to uncover and address security flaws.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/webapp-vapt')}>
                                    Learn More
                                </button>
                            </div>
                            <div className="service-box">
                                <h3>Wireless & IoT Testing</h3>
                                <p>
                                    Examine your wireless networks and IoT devices to mitigate risks from connected systems.
                                </p>
                                <button className="learn-more" onClick={() => handleNavigation('/wireless-vapt')}>
                                    Learn More
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
};

export default VAPT;
